<template>
  <div id="app">
    <nav>
      <div class="nav-wrapper">
        <router-link to="/" class="brand-logo center">VENTE</router-link>
        <ul class="left">
          <li>
            <router-link to="/" style="display: inherit;">
              <i class="material-icons">home</i>
            </router-link>
          </li>
        </ul>
        <ul class="right">
          <li>
            <router-link to="/basket">
              <i class="material-icons">shopping_cart</i>
            </router-link>
          </li>
        </ul>
      </div>
    </nav>

    <div class="main">
      <div class="container">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import "materialize-css/dist/css/materialize.css";
import axios from "axios";
export default {
  created() {
    if (localStorage.token) {
      axios
        .post(process.env.VUE_APP_VENTE_URL + "/auth/refresh", null, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        })
        .then(response => {
          // login user, store username & store the token
          this.$store.commit("loginUser", response.data.user.name);
          localStorage.setItem("token", response.data.access_token);
        })
        // Si une erreur survient lors du refresh, on déconnecte l'utilisateur
        .catch(error => {
          this.$store.commit("logoutUser");
          localStorage.setItem("token", "");
          this.$router.push({ name: "login-view" });
        });
    }
  }
};
</script>

<style>
nav {
  background-color: #fcd900;
  margin-bottom: 2em;
}
nav .brand-logo {
  color: #1a171a;
}
.brand-logo {
  color: #1a171a;
}
.nav-wrapper i,
nav a.button-collapse,
nav a.button-collapse i {
  color: #1a171a;
}

/* BUTTON MYBRICO */
.btn-brico {
  background-color: #fcd900;
  color: #1a171a;
}
.btn-brico:hover {
  background-color: #ffea67;
}
.btn-brico:focus {
  background-color: #e1be00;
}

/* HELPERS */
.m-t {
  margin-top: 1.5em;
}
.m-b {
  margin-bottom: 1.5em;
}

/* GLOBAL */
label {
  display: block;
  text-align: center;
}

/* INPUT NUMBER */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
  text-align: center;
  height: 35px !important;
  float: left;
  width: 100%;
  padding: 0 !important;
  margin: 0 !important;
  border: 2px solid black !important;
  box-sizing: inherit !important;
}
</style>

